<template>
  <b-modal
    id="modal-add-addition"
    :title="'Zu- / Abschlag hinzufügen'"
    ref="modal"
    ok-only
    no-close-on-backdrop>

    <ul class="addition-item-list">
      <li v-for="addition of additionsToShow" :key="addition.id">
        <a href="javascript:void(0);" @click="() => addAddition(addition)">
          {{ addition.displayText }}
        </a>
      </li>
    </ul>
  </b-modal>
</template>

<script>
import {ref, computed} from "@vue/composition-api";

export default {
  props: {
    usedIds: {
      type: Array,
      default: () => ([]),
    }
  },

  emits: ['add'],

  setup(props, { emit }) {
    const store = window.useStore()

    const modal = ref(null)

    const additions = computed(() => typeof store.state.pwa.deliveries.piglet !== 'undefined' ? store.state.pwa.deliveries.piglet.config['delivery-addition'].data : [])

    const additionsToShow = computed(() => {
      return additions.value.filter(addition => !props.usedIds.includes(addition.id))
    })

    const addAddition = (addition) => {
      emit('add', addition.id)
    }

    return {
      modal,
      additionsToShow,
      addAddition,
    }
  }
}
</script>
